webpackJsonp([34],{

/***/ "./.intermediate-representation/json/documentation-methods-paginate.json":
/***/ function(module, exports) {

	module.exports = {
		"data": {
			"site": {
				"siteMetadata": {
					"title": "KeystoneJS"
				}
			},
			"allMarkdownRemark": {
				"edges": [
					{
						"node": {
							"section": "Introduction",
							"slug": "/introduction/getting-started",
							"headings": [
								{
									"value": "Getting Started"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Configuration",
							"slug": "/documentation/configuration",
							"headings": [
								{
									"value": "Keystone Setup Options"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Database",
							"slug": "/documentation/database",
							"headings": [
								{
									"value": "Database Options"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Database",
							"slug": "/documentation/database/relationships",
							"headings": [
								{
									"value": "Relationships"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field",
							"headings": [
								{
									"value": "Field types"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/options",
							"headings": [
								{
									"value": "Field Options"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/add",
							"headings": [
								{
									"value": "Add"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list",
							"headings": [
								{
									"value": "List"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/model",
							"headings": [
								{
									"value": "Model"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/options",
							"headings": [
								{
									"value": "List Construction Options"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/register",
							"headings": [
								{
									"value": "Register"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/schema",
							"headings": [
								{
									"value": "Schema"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation List",
							"slug": "/documentation/list/update-item",
							"headings": [
								{
									"value": "Update Item"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/close-database-connection",
							"headings": [
								{
									"value": "Close Database connection"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/create-items",
							"headings": [
								{
									"value": "Create Items"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/create-router",
							"headings": [
								{
									"value": "Create Router"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/get",
							"headings": [
								{
									"value": "Get"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/import",
							"headings": [
								{
									"value": "Import"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/importer",
							"headings": [
								{
									"value": "Importer"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods",
							"headings": [
								{
									"value": "Methods"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/init",
							"headings": [
								{
									"value": "Init"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/list",
							"headings": [
								{
									"value": "list"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/middleware",
							"headings": [
								{
									"value": "Middleware"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/open-database-connection",
							"headings": [
								{
									"value": "Open Database Connection"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/paginate",
							"headings": [
								{
									"value": "Paginate"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/pre",
							"headings": [
								{
									"value": "Pre"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/set",
							"headings": [
								{
									"value": "Set"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/start",
							"headings": [
								{
									"value": "Start"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Methods",
							"slug": "/documentation/methods/update-handler",
							"headings": [
								{
									"value": "Update Handler"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation View",
							"slug": "/documentation/view",
							"headings": [
								{
									"value": "View"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation View",
							"slug": "/documentation/view/on",
							"headings": [
								{
									"value": "on"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation View",
							"slug": "/documentation/view/query",
							"headings": [
								{
									"value": "query"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation View",
							"slug": "/documentation/view/render",
							"headings": [
								{
									"value": "render"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides/api-file-image-uploads",
							"headings": [
								{
									"value": "API File and Image Uploads"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides/how-to-create-a-blog-with-keystone",
							"headings": [
								{
									"value": "How to create a blog with Keystone"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides/how-to-send-emails",
							"headings": [
								{
									"value": "How to send emails with Keystone"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides",
							"headings": [
								{
									"value": "Guides"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides/v-0-3-to-v-4-0-upgrade-guide",
							"headings": [
								{
									"value": "Upgrade Guide: 0.3 to 4.0"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides",
							"slug": "/guides/yo-generator",
							"headings": [
								{
									"value": "Keystone Yeoman Generator"
								},
								{
									"value": "Routes & Views"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides Setting Up",
							"slug": "/guides/setting-up/part-1",
							"headings": [
								{
									"value": "Part 1: Initial Setup"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides Setting Up",
							"slug": "/guides/setting-up/part-2",
							"headings": [
								{
									"value": "Part 2 - Database Setup"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides Setting Up",
							"slug": "/guides/setting-up/part-3",
							"headings": [
								{
									"value": "Part 3: Routing"
								}
							]
						}
					},
					{
						"node": {
							"section": "Guides Setting Up",
							"slug": "/guides/setting-up/part-4",
							"headings": [
								{
									"value": "Part 4 -  Adding data to the database from a form"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/azurefile",
							"headings": [
								{
									"value": "AzureFile Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/embedly",
							"headings": [
								{
									"value": "Embedly Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/file",
							"headings": [
								{
									"value": "File Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/localfile",
							"headings": [
								{
									"value": "LocalFile Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/localfiles",
							"headings": [
								{
									"value": "Local Files"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/s-3-file",
							"headings": [
								{
									"value": "S3 File Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/boolean",
							"headings": [
								{
									"value": "Boolean Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/cloudinaryimage",
							"headings": [
								{
									"value": "CloudinaryImage Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/cloudinaryimages",
							"headings": [
								{
									"value": "CloudinaryImages Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/code",
							"headings": [
								{
									"value": "Code Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/color",
							"headings": [
								{
									"value": "Color Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/date",
							"headings": [
								{
									"value": "Date Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/datearray",
							"headings": [
								{
									"value": "Datearray field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/datetime",
							"headings": [
								{
									"value": "DateTime Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/email",
							"headings": [
								{
									"value": "Email Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/geopoint",
							"headings": [
								{
									"value": "GeoPoint Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/html",
							"headings": [
								{
									"value": "HTML Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/key",
							"headings": [
								{
									"value": "Key Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/location",
							"headings": [
								{
									"value": "Location Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/markdown",
							"headings": [
								{
									"value": "Markdown Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/money",
							"headings": [
								{
									"value": "Money Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/name",
							"headings": [
								{
									"value": "Name Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/number",
							"headings": [
								{
									"value": "Number Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/numberarray",
							"headings": [
								{
									"value": "NumberArray field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/password",
							"headings": [
								{
									"value": "Password Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/relationship",
							"headings": [
								{
									"value": "Relationship Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/select",
							"headings": [
								{
									"value": "Select Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/text",
							"headings": [
								{
									"value": "Text Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/textarea",
							"headings": [
								{
									"value": "Textarea Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/textarray",
							"headings": [
								{
									"value": "Textarray Field"
								}
							]
						}
					},
					{
						"node": {
							"section": "Documentation Field",
							"slug": "/documentation/field/url",
							"headings": [
								{
									"value": "URL Field"
								}
							]
						}
					}
				]
			},
			"markdownRemark": {
				"parent": {
					"relativePath": "Documentation/Methods/paginate.md"
				},
				"slug": "/documentation/methods/paginate",
				"headings": [
					{
						"value": "Paginate"
					}
				],
				"html": "<h1 id=\"paginate\"><a href=\"#paginate\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Paginate</h1>\n<p>This is a keystone-specific way of retrieving items from <code>mongo</code>. It returns a query object, just as <code>List.model.find()</code> would. It supports the options</p>\n<ul>\n<li><code>page</code> - page to start at</li>\n<li><code>perPage</code> - number of results to return per page</li>\n<li><code>maxPages</code> - optional, causes the page calculation to omit pages from the beginning/middle/end(useful if you have lots of pages, and do not want them to wrap over several lines).</li>\n</ul>\n<p><strong>For example</strong>:</p>\n<p>to load the <code>posts</code> with the <code>maxPages</code> 10 and <code>perPage</code> 10, with state is <code>published</code>, populating the linked <code>author</code> and <code>categories</code>, sorted by reverse published date:</p>\n<p><strong>Loading Posts with paginate</strong></p>\n<pre><code class=\"language-javascript\"><span class=\"token keyword\">var</span> keystone <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">var</span> Post <span class=\"token operator\">=</span> keystone<span class=\"token punctuation\">.</span><span class=\"token function\">list</span><span class=\"token punctuation\">(</span><span class=\"token string\">'Post'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\nPost<span class=\"token punctuation\">.</span><span class=\"token function\">paginate</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n\t   page<span class=\"token punctuation\">:</span> req<span class=\"token punctuation\">.</span>query<span class=\"token punctuation\">.</span>page <span class=\"token operator\">||</span> <span class=\"token number\">1</span><span class=\"token punctuation\">,</span>\n\t   perPage<span class=\"token punctuation\">:</span> <span class=\"token number\">10</span><span class=\"token punctuation\">,</span>\n\t   maxPages<span class=\"token punctuation\">:</span> <span class=\"token number\">10</span>\n   <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n   <span class=\"token punctuation\">.</span><span class=\"token function\">sort</span><span class=\"token punctuation\">(</span><span class=\"token string\">'-publishedDate'</span><span class=\"token punctuation\">)</span>\n   <span class=\"token punctuation\">.</span><span class=\"token function\">populate</span><span class=\"token punctuation\">(</span><span class=\"token string\">'author categories'</span><span class=\"token punctuation\">)</span>\n   <span class=\"token punctuation\">.</span><span class=\"token function\">exec</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">function</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> results<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n\t   locals<span class=\"token punctuation\">.</span>data<span class=\"token punctuation\">.</span>posts <span class=\"token operator\">=</span> results<span class=\"token punctuation\">;</span>\n\t   <span class=\"token function\">next</span><span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n   <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<blockquote>\n<p>NOTE: All parameters of your search should be passed in to the paginate method. Adding additional specificity through calls to mongoose methods such as <code>where</code> will not be properly respected.</p>\n</blockquote>\n<p>When you call <code>exec</code> on a paginated query, it will return a lot of metadata along with the results:</p>\n<table>\n<thead>\n<tr>\n<th>key</th>\n<th>details</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td><code>total</code></td>\n<td>all matching results (not just on this page)</td>\n</tr>\n<tr>\n<td><code>results</code></td>\n<td>array of results for this page</td>\n</tr>\n<tr>\n<td><code>currentPage</code></td>\n<td>the index of the current page</td>\n</tr>\n<tr>\n<td><code>totalPages</code></td>\n<td>the total number of pages</td>\n</tr>\n<tr>\n<td><code>pages</code></td>\n<td>array of pages to display</td>\n</tr>\n<tr>\n<td><code>previous</code></td>\n<td>index of the previous page, false if at the first page</td>\n</tr>\n<tr>\n<td><code>next</code></td>\n<td>index of the next page, false if at the last page</td>\n</tr>\n<tr>\n<td><code>first</code></td>\n<td>the index of the first result included</td>\n</tr>\n<tr>\n<td><code>last</code></td>\n<td>index of the last result included</td>\n</tr>\n</tbody>\n</table>"
			}
		},
		"pathContext": {
			"slug": "/documentation/methods/paginate"
		}
	};

/***/ }

});


// WEBPACK FOOTER //
// path---documentation-methods-paginate-1c81761a55ceacaf526a.js